<script lang="ts">
  import type { VoteStatus } from '../shared/codecs/Vote'
  import { createEventDispatcher } from 'svelte'
  import { goto } from '@roxi/routify'
  import CtaButton from '../Generic/CtaButton.svelte'
  export let heading: string
  export let green_text: string
  export let amber_text: string
  export let red_text: string
  export let your_vote: VoteStatus = 'pending'
  export let show_buttons = false
  export let id: undefined | string = undefined
  const dispatch = createEventDispatcher()
  export let on_delete_button: (() => void) | undefined = undefined
</script>

<div class="card">
  <h3 class="heading">
    {heading}
  </h3>
  <div class="card-row {your_vote !== 'pending' && your_vote !== 'green' ? 'unselected' : ''}">
    <p class="green">
      {green_text}
    </p>

    <button class="green light" on:click={() => dispatch('vote', 'green')} disabled={your_vote === 'green'} />
  </div>
  <div class="card-row {your_vote !== 'pending' && your_vote !== 'amber' ? 'unselected' : ''}">
    <p class="amber">
      {amber_text}
    </p>

    <button class="amber light" on:click={() => dispatch('vote', 'amber')} disabled={your_vote === 'amber'} />
  </div>
  <div class="card-row {your_vote !== 'pending' && your_vote !== 'red' ? 'unselected' : ''}">
    <p class="red">
      {red_text}
    </p>

    <button class="red light" on:click={() => dispatch('vote', 'red')} disabled={your_vote === 'red'} />
  </div>

  {#if show_buttons}
    <div class="buttons-container">
      <div class="delete-button">
        <CtaButton on:click={on_delete_button} kind="negative">Delete</CtaButton>
      </div>
      <div class="edit-button">
        <CtaButton on:click={() => void $goto('/cards/:id', { id })}>Edit</CtaButton>
      </div>
    </div>
  {/if}
</div>

<style>
  .card {
    --row-height: 5em;
    --card-size: 26em;
    --light-size: var(--row-height);
  }
  div.card {
    margin: 1em;
    padding: 0.5em;
    gap: 0.2em;
    border-radius: 2.5em;
    max-width: var(--card-size);
    max-height: var(--card-size);
    background-color: var(--tsf-light-blue);
    display: flex;
    flex-direction: column;
    display: grid;
    grid-template-columns: 1fr;
  }

  .card-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 0.5rem;
    transition: opacity 0.2s ease;
  }

  .card-row + .card-row {
    border-top: 2px dotted rgba(10, 0, 40, 0.12);
  }
  .light {
    border: 0px solid transparent;
    cursor: pointer;
    transition: transform 0.2s ease-in-out, opacity 0.2s ease, border 0.2s ease;
  }
  .green.light,
  .amber.light,
  .red.light {
    flex: 0 0 auto;
    margin-left: 1rem;
  }

  .light:hover {
    filter: brightness(120%);
    transform: scale3d(1.12, 1.12, 1.12);
  }

  .unselected {
    opacity: 0.75;
  }

  .unselected .light {
    transform: scale3d(0.75, 0.75, 0.75);
  }

  .light:active {
    filter: brightness(95%);
    transform: scale3d(0.98, 0.98, 0.98);
  }
  .green.light {
    background-color: var(--green-light);
    box-shadow: 0 2px 4px rgba(8, 136, 29, 0.35);
  }

  .amber.light {
    background-color: var(--amber-light);
    box-shadow: 0 2px 4px rgba(136, 76, 8, 0.35);
  }

  .red.light {
    background-color: var(--red-light);
    box-shadow: 0 2px 4px rgba(136, 8, 8, 0.35);
  }

  .light {
    grid-column: 2 / span 1;
    height: var(--light-size);
    width: var(--light-size);
    border-radius: calc(var(--light-size) / 2);
  }

  .light:disabled {
    filter: brightness(120%);
    border: 3px solid rgba(255, 255, 255, 0.25);
  }

  p {
    grid-column: 1 / span 1;
    margin: 0;
    max-height: var(--row-height);
    overflow: auto;
  }

  p.red {
    padding: 0.5em 0em;
  }

  .buttons-container {
    display: grid;
    grid-column: 1 / span 2;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
  }

  .edit-button {
    margin-left: 1em;
    margin-right: 1em;
  }
  .delete-button {
    margin-left: 1em;
    margin-right: 1em;
  }
</style>
